
/* 
  Gets Data from the s3 Bucket
  < input = None >
 < output = s3Data filtered based on email > 
*/

export async function getAllSnapshotsData(S3) {
  if(localStorage.getItem("s3Link") === null || localStorage.getItem("s3Link") === "") return [];
  // S3 bucket and prefix
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const prefix = localStorage.getItem("s3Link") + "/Forms" + "/Snapshots";

  try {
    // Fetch objects in bucket with prefix
    const s3Response = await S3
    .listObjectsV2({Bucket: bucket,Prefix: prefix})
    .promise();

    // Process S3 objects and the tags assigned to them
    const dataPromises = s3Response.Contents.filter(
      (item) => !item.Key.endsWith("/")
    ).map(async (item) => {
      const nameParts = item.Key.split("/");
      const name = nameParts[nameParts.length - 1].split(".")[0];

      // Tags on files
      const taggingResponse = await S3
      .getObjectTagging({
        Bucket: bucket,
        Key: item.Key,
      })
      .promise();
      const statusTag = taggingResponse.TagSet.find(
        (tag) => tag.Key === "status"
      );
      const status = statusTag ? statusTag.Value : "";
      const uploadedByTag = taggingResponse.TagSet.find(
        (tag) => tag.Key === "uploadedBy"
      );
      const uploadedBy = uploadedByTag ? uploadedByTag.Value : "";

      return {
        date: item.LastModified.toLocaleString(),
        name: name,
        status: status,
        by: uploadedBy,
      };
    });

    const data = await Promise.all(dataPromises);

    // Recession testing

    // Filter the data based on the user's email
    const email = localStorage.getItem("email");
    const filteredData = data.filter((item) => item.by === email);

    return filteredData;

  } catch (error) {
    console.error(error);
    return [];
  }
}
